export default __webpack_public_path__ + "assets/475c190c531e57076f6f2fd498ef9070.jpg";